import { FT5_VIEW_FEATURES_TRACKING, FT5_VIEW_TRACKING } from '../../constants';
import { TrackingEventEmitter } from './tracking-event-emitter';
import { TrackingDataExtractor } from './tracking-data-extractor';
import { TrackingHtmlConditionChecker } from './tracking-html-condition-checker';
import { BCT_TRACKING_ADD_FEATURES_TO_PI, BCT_TRACKING_ADD_TO_EVENT, BCT_TRACKING_ADD_TO_PI } from '../../_common/client/bct-event-topics';
import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { TrackingFeatures } from './event-data-types';
import { eventQBus } from '@otto-ec/global-resources/event-q-bus';

const DATA_ATTRIBUTE_VIEW_TRACKING = 'data-ft5-view-tracking';

export class ViewTracking {
    constructor(
        private eventEmitter: TrackingEventEmitter,
        private trackingDataExtractor: TrackingDataExtractor,
        private htmlConditionChecker: TrackingHtmlConditionChecker
    ) {}

    public registerViewTrackingFromCode(): void {
        eventQBus.on(FT5_VIEW_TRACKING, (trackingData: Record<string, unknown>) => {
            this.doTrackPageImpression(trackingData);
        });

        eventQBus.on(FT5_VIEW_FEATURES_TRACKING, (trackingData: TrackingFeatures) => {
            this.eventEmitter.emitTrackingEvent(BCT_TRACKING_ADD_FEATURES_TO_PI, trackingData);
        });
    }

    public performHtmlViewTracking(): void {
        const viewTrackingTargets = document.querySelectorAll(`[${DATA_ATTRIBUTE_VIEW_TRACKING}]`);
        for (let i = 0; i < viewTrackingTargets.length; i++) {
            const trackingData = this.trackingDataExtractor.extractTrackingData(viewTrackingTargets[i], DATA_ATTRIBUTE_VIEW_TRACKING);
            if (trackingData && this.htmlConditionChecker.isConditionMet(viewTrackingTargets[i])) {
                this.doTrackPageImpression(trackingData);
            }
        }
    }

    private doTrackPageImpression(trackingData: Record<string, unknown>) {
        if (o_product.state.isVariationChanged) {
            this.eventEmitter.emitTrackingEvent(BCT_TRACKING_ADD_TO_EVENT, trackingData, getGlobalEventMergeId());
        } else {
            this.eventEmitter.emitTrackingEvent(BCT_TRACKING_ADD_TO_PI, trackingData);
        }
    }
}
